var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex message d-flex message-bot messsge-loading",
      style: { "font-size": "14vw" },
      attrs: { "aria-hidden": "true" }
    },
    [
      _c(
        "v-layout",
        { staticClass: "message-layout", attrs: { column: "", "ma-2": "" } },
        [
          _c(
            "v-flex",
            {
              directives: [{ name: "scroll", rawName: "v-scroll" }],
              staticClass: "message-bubble-date-container",
              attrs: { "d-flex": "" }
            },
            [
              _c(
                "v-layout",
                { staticClass: "message-bubble-column", attrs: { column: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      directives: [{ name: "scroll", rawName: "v-scroll" }],
                      staticClass: "message-bubble-avatar-container",
                      attrs: { "d-flex": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        {
                          staticClass: "message-bubble-row",
                          attrs: { row: "" }
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                { name: "scroll", rawName: "v-scroll" }
                              ],
                              staticClass: "message-bubble",
                              staticStyle: { display: "block" },
                              attrs: { "aria-hidden": "true" }
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.progress))])]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }